export default __webpack_public_path__ + "static/media/video.bd0717d2.mp4";